fragment DromoImportFragment on DromoImport {
    id: originId
    importStatus
    canRevert
    displayStatus
    startTime
    fileName
    dromoRawFileUrl
    initiatingUser {
        name
    }
}
